import { Card, Typography } from 'antd'
import { formatDateTime } from '../lib/dateFormat'

const { Text } = Typography

export function unresolvedReturnForStatus(history = [], status) {
  const unresolved = []
  for (const event of history) {
    if (event.kind === 'return') {
      unresolved.push(event)
      continue
    }
    if (event.kind !== 'response') continue
    for (let index = unresolved.length - 1; index >= 0; index -= 1) {
      if (unresolved[index].to_status === event.from_status) {
        unresolved.splice(index, 1)
        break
      }
    }
  }
  return [...unresolved].reverse().find(event => event.to_status === status) || null
}

export default function ReturnHistory({ appraisal, compact = false, newestFirst = false }) {
  const recorded = appraisal?.return_history || []
  const history = recorded.length ? [...recorded] : appraisal?.return_comments ? [{
    id: 'legacy-return', kind: 'return', comments: appraisal.return_comments,
    actor_name: appraisal.returned_by_name || appraisal.returned_by_email,
    created_at: appraisal.returned_at
  }] : []
  if (!history.length) return null
  if (newestFirst) history.sort((a, b) => (
    (Date.parse(b.created_at) || 0) - (Date.parse(a.created_at) || 0) || recorded.indexOf(b) - recorded.indexOf(a)
  ))

  if (compact) return (
    <div role='log' aria-label='Comments history'>
      {history.map((event, index) => (
        <article key={event.id} aria-label={index === 0 ? 'Latest comment' : 'Earlier comment'} className={`tti-review-comment${index === 0 && newestFirst ? ' tti-review-comment--latest' : ''}`}>
          <Text strong className='tti-review-comment__author'>{event.kind === 'response' ? 'Resubmission response' : 'Returned for changes'} — {event.actor_name || 'Former user'}</Text>
          <div style={{ whiteSpace: 'pre-wrap' }}>{event.comments}</div>
          {event.created_at && <Text type='secondary'>{formatDateTime(event.created_at)}</Text>}
        </article>
      ))}
    </div>
  )

  return (
    <Card title='Return and resubmission history' size='small' style={{ marginBottom: 24 }}>
      {history.map(event => (
        <div key={event.id} style={{ marginBottom: 12, borderBottom: '1px solid #eee', paddingBottom: 12 }}>
          <Text strong>{event.kind === 'response' ? 'Resubmission response' : 'Returned for changes'} — {event.actor_name || 'Former user'}</Text>
          <Text type='secondary' style={{ marginLeft: 8 }}>{formatDateTime(event.created_at)}</Text>
          <div style={{ whiteSpace: 'pre-wrap' }}>{event.comments}</div>
        </div>
      ))}
    </Card>
  )
}
